/**
 * Full-screen fallback shown while `GameProvider`'s `connectionStatus` is
 * 'unreachable'. The server is mandatory (Phase 3, docs/ROADMAP.md) — there
 * is deliberately no "continue offline" affordance here; `GameProvider`
 * already retries `getState()` every few seconds in the background, so this
 * screen just needs to explain what's happening.
 */

export function ConnectionError() {
  return (
    <div className="sg-root flex min-h-screen flex-col items-center justify-center gap-3 bg-surface-base p-6 text-center">
      <p className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-content">
        Keine Verbindung zum Server
      </p>
      <p className="max-w-sm text-xs leading-relaxed text-content-muted">
        Dyson Warfare braucht eine aktive Verbindung, um Cheats auszuschließen — dein Spielstand
        lebt sicher auf dem Server. Wir versuchen laufend automatisch, die Verbindung
        wiederherzustellen.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-control border border-edge-strong bg-surface-2 px-3 py-1.5 font-display text-label uppercase text-content hover:bg-surface-3"
      >
        Neu laden
      </button>
    </div>
  );
}
